<template>
  <div class="Course">
    <div class="banner">
      <img src="../assets/course/banner.png" alt />
      <div class="simtitle">
        <div class="left" style="padding-left: 40px">
          <img src="../assets/course/logo.png" alt />
          <span style="font-weight: bold">课程中心</span>
        </div>
        <div>
          <a-input-search
            placeholder="搜索感兴趣的课程"
            v-model="key"
            style="width: 350px"
            @search="onSearch"
          />
        </div>
      </div>
    </div>

    <!-- 筛选 -->
    <div class="filterbox">
      <div class="filter">
        <div class="onder">
          <div class="left">
            <span class="mojortitle">专业方向：</span>
            <span class="allmojor" :class="{ act: isshow }" @click="getmojorAll"
              >全部</span
            >
          </div>
          <ul>
            <li
              v-for="(item, index) in mojorList"
              :key="index"
              :class="{ active: current == index }"
              @click="changemojor(index, item.id)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="under">
          <div class="left">
            <span class="mojortitle">课程类别：</span>
            <span
              class="allmojor"
              :class="{ act: isexit }"
              @click="getcourseAll"
              >全部</span
            >
          </div>
          <ul>
            <li
              v-for="(item, index) in courseList"
              :key="index"
              :class="{ active: currentindex == index }"
              @click="changecourse(index, item.id)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 筛选1 -->
    <div class="findbox">
      <div class="find">
        <span>筛选：</span>
        <ul>
          <li
            v-for="(item, index) in isFreeList"
            :key="index"
            :class="{ active: freeindex == index }"
            @click="changeFree(index, item)"
          >
            <span>{{ item }}</span>
          </li>
        </ul>
      </div>
    </div>

    <!-- 列表 -->
    <div class="box">
      <div class="notbox" v-if="List.length == 0">
        <img src="../assets/blank/notlist.png" alt="" />
        <p class="inp">暂无内容</p>
      </div>
      <ul class="boxul" v-else>
        <li
          v-for="(item, index) in List"
          :key="index"
          @click="toDetail(item.id)"
        >
          <div class="cover">
            <img :src="item.cover" alt />
          </div>
          <div class="detail">
            <p class="coursetit" :title="item.title">{{ item.title }}</p>
            <p class="coursetea">
              <span>讲师：{{ item.teacher }}</span>
              <span v-if="item.isFree == 1" style="backaground: #41b5f1"
                >免费</span
              >
              <span v-else style="background: #ea5442">VIP</span>
            </p>
          </div>
        </li>
      </ul>
      <div class="page">
        <pagination
          :pagination="pagination"
          @changePage="changePage"
          :isChange="searchInfo.page"
        ></pagination>
      </div>
    </div>

    <!-- 返回顶部按钮 -->
    <div class="gohead" v-show="flaghead">
      <a href="#layout"></a>
    </div>
  </div>
</template>

<script>
import { getcourseListApi, getcoursecommonApi } from "@/request/api";
import pagination from "@/components/common/pagination";
export default {
  name: "Course",
  components: { pagination },
  data() {
    return {
      mojorList: [],
      courseList: [],
      isFreeList: ["全部", "免费", "会员"],
      List: [],
      isshow: true,
      isexit: true,
      current: null,
      currentindex: null,
      freeindex: "",
      searchInfo: {
        page: 1,
        pageSize: 16,
        keyword: "",
        majorId: "",
        isFree: "",
      },
      pagination: { total: "", pageSize: 16 },
      flaghead: false,
      key: "",
    };
  },
  mounted() {
    window.addEventListener("scroll", this.watchScroll);
  },
  created() {
    this.init();
    this.getMajorList();
  },
  methods: {
    init() {
      this.getToken(getcourseListApi, this.searchInfo, (res) => {
        this.List = res.data.rows;
        this.pagination.total = res.data.count;
      });
    },
    getMajorList() {
      this.getToken(getcoursecommonApi, this.searchInfo, (res) => {
        this.mojorList = res.data;
        // console.log(this.mojorList)
        this.courseList = [];
        res.data.forEach((item) => {
          item.children.forEach((v) => {
            this.courseList.push(v);
          });
        });
      });
    },
    //搜索
    onSearch() {
      this.searchInfo.keyword = this.key;
      this.init();
    },
    //专业全部
    getmojorAll() {
      this.isshow = true;
      this.current = null;
      this.searchInfo.majorId = "";
      this.init();
      this.getMajorList();
    },
    //专业切换
    changemojor(index, id) {
      this.current = index;
      this.isshow = false;
      this.courseList = this.mojorList.filter(
        (item) => item.id == id
      )[0].children;
      this.searchInfo.majorId = id;
      this.searchInfo.page=1
      this.init();
    },
    //教学模块全部
    getcourseAll() {
      this.isexit = true;
      this.currentindex = null;
      if (this.current == null) {
        this.searchInfo.majorId = "";
      } else {
        this.searchInfo.majorId = this.mojorList[this.current].id;
      }
      this.init();
    },
    //教学模块切换
    changecourse(index, id) {
      this.currentindex = index;
      this.isexit = false;
      this.searchInfo.majorId = id;
      this.searchInfo.page=1
      this.init();
    },
    //是否免费
    changeFree(index, item) {
      this.freeindex = index;
      if (item == "全部") {
        this.searchInfo.isFree = null;
        this.init();
      } else if (item == "免费") {
        this.searchInfo.isFree = 1;
        this.searchInfo.page=1
        this.init();
      } else {
        this.searchInfo.isFree = 0;
        this.searchInfo.page=1
        this.init();
      }
    },
    //分页
    changePage(currentPage) {
      this.searchInfo.page = currentPage;
      this.init();
    },
    //去详情页
    toDetail(id) {
      this.$router.push({ path: "/courseInfo", query: { id:this.$Base64.encode(id)} });
    },
    //返回顶部
    watchScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 100) {
        this.flaghead = true;
      } else {
        this.flaghead = false;
      }
    },
  },
};
</script>
<style lang="stylus">
.ant-input-affix-wrapper .ant-input:not(:last-child) {
  padding-right: 30px;
  border-radius: 0px;
  background: #fff;
}

.ant-input::-webkit-input-placeholder {
  color: #666;
}
</style>
<style lang="stylus" scoped>
.Course {
  background: #eff3f5;
  overflow: hidden;

  .banner {
    height: 100px;
    margin: 0 auto;
    position: relative;

    img {
      width: 100%;
      height: 100%;
    }

    .simtitle {
      width: 1205px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: 46px;
      position: absolute;
      left: 50%;
      bottom: 23px;
      transform: translateX(-50%);
      z-index: 555;

      .left {
        display:flex;
        justify-content: space-between;
        align-items: center;
        img {
          width: 46px;
          height: 46px;
        }

        span {
          font-size: 22px;
          color: #fff;
          margin-left: 11px;
        }
      }
    }
  }

  .filterbox {
    background: #fff;

    .filter {
      width: 1205px;
      overflow: hidden;
      margin: 0 auto;

      .onder {
        margin-top: 30px;
        margin-bottom: 20px;
        align-items: center;
        display: flex;
        font-size: 14px;
        color: #333;

        .left {
          display: flex;
          align-items: center;
          height: 30px;

          .mojortitle {
            width: 76px;
            display: block;
          }

          .allmojor {
            width: 50px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            margin-right: 24px;
            cursor: pointer;
          }

          .act {
            color: #333;
            background-color: #f0cd48;
          }
        }

        ul {
          display: flex;
          margin-bottom: 0px;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          color: #666;

          li {
            margin-right: 35px;
            padding-left: 5px;
            padding-right: 5px;
            padding-top: 5px;
            padding-bottom: 5px;
          }

          li:hover {
            cursor: pointer;
          }

          li:nth-last {
            margin-right: 0px;
          }

          .active {
            color: #333;
            background-color: #f0cd48;
          }
        }
      }

      .under {
        border-top: 1px solid #edf1f2;
        padding-top: 20px;
        padding-bottom:10px;
        display: flex;
        font-size: 14px;
        color: #333;

        .left {
          display: flex;
          align-items: center;
          height: 30px;

          .mojortitle {
            width: 76px;
            display: block;
          }

          .allmojor {
            width: 50px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            margin-right: 24px;
            cursor: pointer;
          }

          .act {
            color: #333;
            background-color: #f0cd48;
          }
        }

        ul {
          display: flex;
          margin-bottom: 0px;
          display: flex;
          flex-wrap: wrap;
          color: #666;

          li {
            margin-right: 35px;
            padding-left: 5px;
            padding-right: 5px;
            padding-top: 5px;
            padding-bottom: 5px;
            margin-bottom: 10px;
          }

          li:hover {
            cursor: pointer;
          }

          li:nth-last {
            margin-right: 0px;
          }

          .active {
            color: #333;
            background-color: #f0cd48;
          }
        }
      }
    }
  }

  .findbox {
    height: 68px;
    line-height: 68px;

    .find {
      margin: 0 auto;
      width: 1205px;
      display: flex;
      align-items: center;

      span {
        color: #333333;
        font-size: 14px;
        margin-right: 5px;
      }

      ul {
        display: flex;
        margin-bottom: 0px;
        align-items: center;

        li {
          width: 65px;
          text-align: center;
          height: 20px;
          line-height: 20px;
          border-right: 1px solid #c6cee1;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;

          span {
            width: 50px;
            height: 30px;
            line-height: 30px;
            display: block;
            margin-left: 5px;
          }
        }

        li:last-child {
          border: 0;
        }

        .active {
          span {
            background-color: #f0cd48;
            color: #333;
          }
        }
      }
    }
  }

  .box {
    width: 1205px;
    margin: 0 auto;

    .notbox {
      margin: 0 auto;
      margin-bottom: 30px;
      margin-top: 40px;
      width: 1205px;
      text-align: center;
      height:300px;

      img {
        display: block;
        margin: 0 auto;
      }

      .inp {
        font-size: 18px;
        color: #666;
        margin: 0 auto;
        text-align: center;
        margin-top: 10px;
      }
    }

    .boxul {
      display: flex;
      flex-wrap: wrap;

      li {
        width: 284px;
        margin-right: 22px;
        margin-bottom: 30px;

        .cover {
          width: 284px;
          height: 161px;
          overflow: hidden;

          img {
            width: 284px;
            height: 161px;
            transition: all 1s;
          }
        }

        .detail {
          overflow: hidden;

          .coursetit {
            width: 200px;
            margin-top: 15px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-bottom: 8px;
            color: #333;
            font-size: 16px;
          }

          .coursetea {
            position: relative;
            margin-bottom: 0px;

            span:nth-child(1) {
              font-size: 14px;
              color: #666;
            }

            span:nth-child(2) {
              width: 34px;
              height: 18px;
              line-height: 18px;
              color: #fff;
              font-size: 12px;
              background-color: #41b5f1;
              border-radius: 2px;
              display: block;
              text-align: center;
              position: absolute;
              right: 13px;
              top: 0;
            }
          }
        }
      }

      li:nth-child(4n) {
        margin-right: 0px;
      }

      li:hover {
        cursor: pointer;

        .cover {
          img {
            transform: scale(1.3); // 放大 倍数随意
          }
        }

        .coursetit {
          color: #ef9545;
        }
      }
    }
  }
}

.page {
  padding-bottom: 30px;
}

.gohead {
  width: 66px;
  height: 58px;
  background-color: #f9f9fa;
  border-radius: 3px;
  border: solid 1px #eeeeee;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  right: 240px;
  bottom: 50px;
  cursor: pointer;

  a {
    width: 33px;
    height: 32px;
    display: inline;
    text-align: center;
    background: url('../assets/home/gohead3.png') -18px -15px no-repeat;
  }
}

.gohead:hover {
  a {
    background: url('../assets/home/gohead4.png') -18px -15px no-repeat;
  }
}

.gohead:active {
  a {
    background: url('../assets/home/gohead4.png') -18px -15px no-repeat;
  }
}
</style>
